import React from 'react';

import { LiveShoutout } from '../utils/Shoutouts';

import './ShoutoutPopup.scss';

interface ShoutoutPopupProps {
  shoutout: LiveShoutout;
  /** During trivia it sits in the narrower column under the video. */
  compact?: boolean;
}

/** Messages longer than this get a smaller size so they fit on two lines. */
const LONG_MESSAGE = 40;

/**
 * A newly approved shout-out, big, for a few seconds before it drops into the ticker. The
 * same coral pill, gold edge and 📣 badge as in the ticker. It goes where the screen has room
 * beside or below the video, never over it: YouTube's API policies forbid drawing anything
 * over the embedded player.
 */
const ShoutoutPopup = ({ shoutout, compact = false }: ShoutoutPopupProps) => {
  const name = shoutout.username || '';
  const initials = name.replace(/[^a-z0-9]/gi, '').slice(0, 2).toUpperCase();
  const className = [
    'shoutout-popup',
    compact ? 'shoutout-popup-compact' : '',
    Array.from(shoutout.message).length > LONG_MESSAGE ? 'is-long' : '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <section className={className} role="status" aria-live="polite" aria-label="Shout-out">
      <div className="shoutout-popup-pill">
        <span className="shoutout-popup-badge" aria-hidden="true">
          📣
        </span>
        {shoutout.profilePicUrl ? (
          <img className="shoutout-popup-avatar" src={shoutout.profilePicUrl} alt="" />
        ) : (
          !!initials && (
            <span className="shoutout-popup-avatar shoutout-popup-initials" aria-hidden="true">
              {initials}
            </span>
          )
        )}
        <div className="shoutout-popup-body">
          {!!name && <div className="shoutout-popup-name">{name}</div>}
          <div className="shoutout-popup-text">{shoutout.message}</div>
        </div>
      </div>
    </section>
  );
};

export default ShoutoutPopup;
